// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2JAej","footer__inline-element":"footer_footer__inline-element__1oarB","footer__link":"footer_footer__link__2uHJo"};